import { Banner, BannerOrigin, BannerType } from '@/app/entities/Banner'
import { httpClient } from '../http/httpClient'

export interface BannerResponse {
  _id: string
  type: BannerType
  banners: Banner[]
}

export const bannerService = {
  async getBanners(type: BannerType, origin?: BannerOrigin) {
    const { data } = await httpClient.get<BannerResponse>(
      `/config/banner/${type}`,
      { params: { origin } },
    )
    return data
  },

  async updateBanners(type: BannerType, banners: Banner[]) {
    const { data } = await httpClient.put<BannerResponse>(
      `/config/banner/${type}`,
      { banners },
    )
    return data
  },

  async uploadBanner(
    type: BannerType,
    file: File,
    banner: Omit<Banner, 'uri'>,
  ) {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('link', banner.link || '')
    formData.append('title', banner.title || '')
    formData.append('description', banner.description || '')
    formData.append('videoUrl', banner.videoUrl || '')
    formData.append('buttonLabel', banner.buttonLabel || '')
    formData.append('isWebApp', `${!!banner?.isWebApp}`)
    formData.append('isTeamsApp', `${!!banner?.isTeamsApp}`)
    formData.append('isSellersApp', `${!!banner?.isSellersApp}`)

    const response = await httpClient.post<BannerResponse>(
      `/config/banner/${type}`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    )

    return response.data
  },
}
